import product1 from '../../images/closeAddOns/p1.png';
import product2 from '../../images/closeAddOns/p2.png';
import product3 from '../../images/closeAddOns/p3.png';
import product4 from '../../images/closeAddOns/p4.png';

export const PRODUCTS_COPY = [
  {
    title: 'Algenist',
    name: 'GENIUS Body Mylk',
    image: product1,
  },
  {
    title: 'tarte',
    name: 'lights, camera, flashes statement mascara',
    image: product2,
  },
  {
    title: 'Kate Somerville',
    name: 'Retinol + Vita C Serum',
    image: product3,
  },
  {
    title: 'bkr',
    name: 'Spiked Muse 500ML Bottle',
    image: product4,
  },
];

export const MEMBERSHIP_COPY = {
  club: [
    {
      title: 'Customize Your Box',
      description: 'Choose from a curated selection of the season’s top finds.',
      icon: 'fal fa-hand-holding-box',
    },
    {
      title: 'Access to Sales & Customization',
      description: 'Get access to Add-Ons, Edit Sales, and Customization.',
      icon: 'fal fa-shopping-bag',
    },
    {
      title: 'Earlier Shipping',
      description: 'Annual members ship in the earliest shipping group.',
      icon: 'fal fa-shipping-fast',
    },
  ],
  default: [
    {
      title: 'More Customization',
      description: 'Get extra Customization options every season.',
      icon: 'fal fa-hand-holding-box',
    },
    {
      title: 'Early Access to Sales & Customization',
      description:
        'Get early access to Add-Ons, Edit Sales, and Customization!',
      icon: 'fal fa-shopping-bag',
    },
    {
      title: 'Earlier Shipping',
      description: 'Your box will ship in the earliest shipping group.',
      icon: 'fal fa-shipping-fast',
    },
  ],
};

export const BUTTON = {
  calendar: {
    name: 'Add To Calendar',
    link: 'https://support.fabfitfun.com/?a=Events-Calendar---id--H0AQUreNRza2n2P3FrgMww',
  },
  shop: {
    name: 'Go To Shop',
    link: 'shop',
  },
  upgrade: {
    name: 'Upgrade To Annual',
    link: 'upgrade-confirmation',
  },
  reactivate: {
    name: 'Reactivate Now',
    link: 'reactivate-my-membership?referrer=add-ons',
  },
  activate: {
    name: 'Activate My Membership',
    link: 'subscribe-today?referrer=add-ons',
  },
};
